import React from 'react';
import { HiMiniWrenchScrewdriver } from 'react-icons/hi2';
import { MdAnchor } from 'react-icons/md';

import { ButtonSmall } from '@/components/Button';
import { Tooltip } from '@/components/Tooltip';
import { MARINA_RIGHTS } from '@/permissions/route-rights';
import { usePermissions } from '@/permissions/usePermissions';

import styles from './ChosenYachtControls.module.scss';

interface ChosenYachtControlsProps {
  onMarinaClick?: () => void;
  onServiceClick?: () => void;
  className?: string;
}

export const ChosenYachtControls: React.FC<ChosenYachtControlsProps> = ({
  onMarinaClick,
  onServiceClick,
  className,
}) => {
  const { canAny } = usePermissions();

  return (
    <div className={`${styles.chosenYachtButtons} ${className || ''}`}>
      {/* My marinas — guests and vendors have nothing to open there. */}
      {/* One word is not an explanation — "Service" could be booking one as easily as
          reading the history — so each says what it opens on hover and on focus.
          `block`: the grid column sizes the button, not the tooltip's wrapper. */}
      {canAny([...MARINA_RIGHTS]) && (
        <Tooltip label="Berth, saved marinas and bookings" block>
          <ButtonSmall type="button" onClick={onMarinaClick}>
            <span className={styles.label}>Marina</span> <MdAnchor />
          </ButtonSmall>
        </Tooltip>
      )}
      <Tooltip label="Service history: what was done, and by whom" block>
        <ButtonSmall type="button" onClick={onServiceClick}>
          <HiMiniWrenchScrewdriver /> <span className={styles.label}>Service</span>
        </ButtonSmall>
      </Tooltip>
    </div>
  );
};
